import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { hasPrivilege } from 'src/app/core/guards/privilege.guard';
import { FeatureFlagService } from '../../util/feature-flag.service';
import { UserDataService } from '../../util/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class LandingRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private featureFlagService: FeatureFlagService,
    private userDataService: UserDataService
  ) {}

  canActivate(): UrlTree {
    const canAccessDashboard =
      this.featureFlagService.flagEnabled('vitals-dashboard') &&
      hasPrivilege(this.userDataService.privileges, 'dashboard/read');
    const destination = canAccessDashboard ? '/dashboard' : '/map';
    return this.router.parseUrl(destination);
  }
}
